import Vue from 'vue'
import Vuex from 'vuex'
import { setLocal, getLocal, removeLocal } from '../common/js/lib.js'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        result: '',
        enter: '',
        selectedCity: getLocal('selectedCity'),
        selectedCityCode: getLocal('selectedCityCode'),
        position: getLocal('position'),
        pickCity: getLocal('pickCity'),
        positionCity: getLocal('positionCity'),
    },
    getters: {
        pickCity: state => state.pickCity,
        positionCity: state => state.positionCity,
        selectedCityName: (state, getters, rootState) => {
            let positionName = state.position ? state.position.name : '';
            return state.selectedCity ? state.selectedCity : positionName;
        },
        selectedCityCode: (state) => {
            let positionCode = state.position ? state.position.citycode : '';
            return state.selectedCityCode ? state.selectedCityCode : positionCode;
        },
        position: (state) => {
            return state.position ? state.position : null;
        }
    },
    mutations: {
        setPickCity(state, value) {
            state.pickCity = value
        },
        setPositionCity(state, value) {
            state.positionCity = value;
        },
        setSelectedCityName(state, value) {
            state.selectedCity = value;
            setLocal('selectedCity', value);
        },
        setSelectedCityCode(state, value) {
            state.selectedCityCode = value;
            setLocal('selectedCityCode', value);
        },
        setPosition(state, value) {
            state.position = value;
            setLocal('position', value);
        },
        calculate(state, value) {
            if (value === '=') {
                //按键的值为=，进行结果计算
                state.result = eval(state.enter);
                state.enter += value;
            } else if (value === 'clear') {
                //按键的值为clear，清空数据
                state.result = state.enter = "";
            } else {
                //输入结果enter进行拼接
                state.enter += value;
            }
        }
    },
    actions: {
        
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js